import React, { useEffect, useState } from 'react';
import './reviewurl.css';
import axios from 'axios';
import { Grid, Stack, Rating } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useParams,useNavigate } from 'react-router-dom';
import ThankYouPage from '../WriteReview/ThankYouPage';
import WriteFeedback from '../WriteReview/WriteFeedback';
import Loader from '../../Loader';
import Header from '../../Header';
import ReviewComponent from '../../Reviews/ReviewComponent';

function ReviewUrl({ baseURL }) {
  const { companyid } = useParams();
  const [page, setPage] = useState(1);
  const [getData, setGetData] = useState(null);
  const [experience, setExperience] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [assistedBy, setAssistedBy] = useState('');
  const [toBeContacted, setToBeContacted] = useState(true);
  // const [data, setData] = useState(null);
  const [companyRating, setCompanyRating] = useState(4.7);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    getReviewURLDetails();
    getAllUsers();
  }, [companyid]);

  const getReviewURLDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/dashboard-review/review-url/${companyid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }, 
      });
      console.log(response, 'getReviewURLDetails res');
      if (response?.data?.status === 'success') {
        setGetData(response?.data?.data?.entity);
        setCompanyRating(response?.data?.data?.entity?.rating_average);
        setLoading(false);
      }
    } catch (err) {
      console.log('getReviewURLDetails err', err);
    }
  };

  const getAllUsers = async () => {
    try {
      const res = await axios.get(`${baseURL}/dashboard/user-unauthenticated-get-all/${companyid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }, 
      });
      // console.log("all users", res);
      const filterUser = res?.data?.data?.entity;
      const AssignLabel = filterUser.filter((entry) => !(entry?.role === 'Km' || entry?.role === 'System'));
      setUsers(AssignLabel);
    } catch (err) {
      console.log('getAllUsers err', err);
    }
  };

  const handleSubmit = async () => {
    console.log('submit check');
    setLoading(true);
    const formData = {
      experience,
      name,
      email,
      assisted_by: assistedBy,
      willing_contacted: toBeContacted,
    };
    try {
      const response = await axios.post(
        `${baseURL}/dashboard-review/write-review/${companyid}`,
        formData,
      );
      console.log(response, 'handleSubmit res');
      if (response.data.data.status === 'success') {
        //   setData(response?.data?.data);
        setPage(page + 1);
        setLoading(false);
      }
    } catch (err) {
      console.log('handleSubmit err', err);
    }
  };

  const handleReviewActivity = async (value) => {
    // console.log('value',value);
    // const formData = {
    //   contact_id: contactid,
    //   activity_action_name: 'clicked',
    //   performed_on: value,
    //   sent_via: type,
    //   template_type: getData.template.template_type_,
    //   company_id: getData?.template?.company_id,
    //   account_id: null,
    // };
    // const res = await axios.post(`${baseURL}/activity/add-activity`, formData);
    // console.log('handleReviewActivity res', res);
    if (value === 'Google' && getData?.template?.review_site_1_platform === 'Google') {
      window.open(getData?.template?.review_site_1_url, '_blank');
    }
    if (value === 'Facebook' && getData?.template?.review_site_2_platform === 'Facebook') {
      window.open(getData?.template?.review_site_2_url, '_blank');
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="qs-page">
      {getData && (      
      <div className="qs-card">
        <div>
          <Header 
            logo={getData?.display?.email_logo}
            headerColor={getData?.display?.email_header_color}
            headerTextColor={getData?.display?.email_header_text_color}
            companyName={getData?.company?.name}
            ratingValue={(getData?.rating_average)}
            reviewCount={getData?.review_count}
          />
        
          {page === 1 && (
            <div className="px-5 pb-6 pt-2 sm:px-8 sm:pb-8">
              <ReviewComponent 
                getData={getData} 
                handleReviewActivity={handleReviewActivity} 
                setPage={setPage}
                page={page}
              />
            </div>
          )}
          {page === 2 && (
            <div>
              <WriteFeedback
                experience={experience}
                setExperience={setExperience}
                name={name}
                setName={setName}
                email={email}
                setEmail={setEmail}
                assistedBy={assistedBy}
                setAssistedBy={setAssistedBy}
                toBeContacted={toBeContacted}
                setToBeContacted={setToBeContacted}
                handleSubmit={handleSubmit}
                usedFor="reviewURL"
                users={users}
                loading={loading}
              />
            </div>
          )}

          <div>
            {page === 3 && (
              <ThankYouPage 
                baseURL={baseURL}
                value={getData}
                companyId={companyid}
              />
            )}

          </div>
        </div>
      </div>
      )}
    </div>
  );
}

export default ReviewUrl;
